import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { ReportService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class ReportListResolve implements Resolve<any> {

  constructor(private reportService: ReportService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.reportService.list(
      route.data.newFirst || route.params.newFirst || route.queryParams.newFirst
    );
  }
}
